import { useContext } from 'react';
import UserflowContext, { IUserflowContext } from '../context/userflowContext';

const useUserflow = (context = UserflowContext): IUserflowContext =>
  useContext(context) as IUserflowContext;

export default useUserflow;
